import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  > span {
    margin-left: 8px;
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  display: none;
  width: auto;
  white-space: nowrap;
  bottom: 30%;
  left: 130%;
  padding: 5px 11px;
  border-radius: 4px;
  background: #273c49;
  font-size: 14px;
  color: #fff;
  z-index: 3;
`;

export const Indicator = styled.div`
  background-color: ${({ $color }) => $color};
  position: relative;
  border-radius: 50%;
  border: 1px solid ${th('colors.white')};
  height: 14px;
  width: 14px;
  ${variants('variant', {
    dark: css`
      border: 1px solid ${th('colors.black')};
    `
  })};
  &:hover {
    ${Tooltip} {
      display: block;
    }
  }
`;
